import type { ModuleFederationRuntimePlugin } from '@module-federation/runtime';

export default function funddataRemoteEntry(): ModuleFederationRuntimePlugin {
  return {
    name: 'funddata-remote-entry',
    beforeRegisterRemote(args) {
      const apiBaseUrl = document.querySelector<HTMLElement>(
        '[data-api-base-url]',
      )?.dataset.apiBaseUrl;
      // Mutate in place: the runtime ignores a replaced remote object.
      if (
        args.remote.name === 'funddata' &&
        'entry' in args.remote &&
        apiBaseUrl
      ) {
        args.remote.entry = new URL('remoteEntry.js', apiBaseUrl).href;
      }
      return args;
    },
  };
}
